<template>
  <nav class="tce-grid-pagination" role="navigation" :aria-label="paginationDictionary.navigation">
    <div class="tce-grid-pagination__previous">
      <button
        v-if="showPrevious"
        :aria-label="paginationDictionary.firstPage"
        class="tce-grid-pagination__button"
        @click="changePage(1)"
      >
        <img src="/ui/icons/arrow-prev-double.svg" alt="" />
      </button>
      <button
        v-if="showPrevious"
        :aria-label="paginationDictionary.previousPage"
        class="tce-grid-pagination__button"
        @click="changePage(currentPaginationPage - 1)"
      >
        <img src="/ui/icons/arrow-prev-thin.svg" alt="" />
      </button>
    </div>
    <div class="tce-grid-pagination__page">
      <div class="tce-grid-pagination__page-current">{{ pagination.page }}</div>
      <div class="tce-grid-pagination__page-divider">/</div>
      <div class="tce-grid-pagination__page-all">{{ pagination.total }}</div>
    </div>
    <div class="tce-grid-pagination__next">
      <button
        v-if="showNext"
        :aria-label="paginationDictionary.nextPage"
        class="tce-grid-pagination__button"
        @click="changePage(currentPaginationPage + 1)"
      >
        <img src="/ui/icons/arrow-next-thin.svg" alt="" />
      </button>
      <button
        v-if="showNext"
        :aria-label="paginationDictionary.lastPage"
        class="tce-grid-pagination__button"
        @click="changePage(pagination.total)"
      >
        <img src="/ui/icons/arrow-next-double.svg" alt="" />
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'tce-grid-pagination',
};
</script>

<script setup>
import { computed, ref, watchEffect } from 'vue';

const props = defineProps({
  pagination: {
    type: Object,
    default: () => {},
  },
  paginationDictionary: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['page-updated']);

const currentPaginationPage = ref(props.pagination.page);

watchEffect(() => {
  currentPaginationPage.value = props.pagination.page;
});

const showPrevious = computed(() => {
  return currentPaginationPage.value > 1;
});

const showNext = computed(() => {
  return currentPaginationPage.value < props.pagination.total;
});

function changePage(page) {
  currentPaginationPage.value = page;

  emit('page-updated', currentPaginationPage.value);

  document.querySelector('.tce-grid-tabs')?.scrollIntoView({ behavior: 'smooth' });
}
</script>
